import React from "react"
import { Link } from "gatsby"
import { styled } from "themes"

export const Section = styled.section`
  background: #f6f7fa;
`

export const Container = styled.div`
  width: 100%;
  padding: 40px 0;
  padding-bottom: 0;
`

export const Headline = styled.h3`
  text-align: center;
  font-size: 31px;
  font-weight: bold;
  margin-bottom: 8px;
  position: relative;
  &::after {
    content: "";
    width: 27px;
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 50%;
    background: ${({ theme }) => theme.color.primary};
    transform: translate(-50%, 0);
  }
`

export const SubHeadline = styled.p`
  color: ${({ theme }) => theme.color.softBlack};
  font-size: 12px;
  text-align: center;
`

export const List = styled.div`
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  z-index: 1;
  overflow-x: auto;
`

export const ListItem = styled.div`
  flex-basis: 268px;
  flex-shrink: 0;
  padding: 16px;
`

export const Action = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
`

export const ActionButton = styled((props: any) => <Link {...props} />)`
  background: ${({ theme }) => theme.color.primary};
  color: ${({ theme }) => theme.color.white};
  text-transform: uppercase;
  border-radius: 4px;
  border: none;
  outline: none;
  font-size: 12px;
  font-weight: 500;
  padding: 15px 72px;
  cursor: pointer;
  margin-right: 16px;
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    color: ${({ theme }) => theme.color.white};
  }
`
